import React, {Component} from 'react'
import {Button, Dropdown, Icon, Modal, Popup, TextArea} from 'semantic-ui-react'
import {bulkCreateCadBuyerReviews} from './api'

class BulkMarkReviewedByBuyer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      accountName: '',
      reviewDate: '',
      comment: ''
    }
  }

  openModal = () => {
    if (this.props.numSelected === 0) {
      alert('Select at least 1 CAD')
      return
    }

    this.setState({open: true, accountName: '', reviewDate: '', comment: ''})
  }

  closeModal = () => {
    this.setState({open: false})
  }

  onDateChange = ({currentTarget}) => {
    this.setState({reviewDate: currentTarget.value})
  }

  fieldOnChange = (event, {value, name}) => {
    let newState = {}
    newState[name] = value
    this.setState(newState)
  }

  onCommentChange = (event, {value}) => {
    this.setState({comment: value})
  }

  save = () => {
    let {accountName, reviewDate, comment} = this.state
    comment = comment.trim()

    if (accountName === '') {
      alert('Please select a contact.')
      return
    }

    if (reviewDate === '') {
      alert('Please select a review date.')
      return
    }

    if (comment === '') {
      alert('Please enter a comment.')
      return
    }

    bulkCreateCadBuyerReviews(this.props.cadIds, accountName, reviewDate, comment, (err, res) => {
      if (err) {
        alert('There was an error when trying to mark CADs as reviewed.')
      } else {
        window.dispatchEvent(new CustomEvent('buyerReviewUpdated', {
          detail: {totals: res.data.totals}
        }))
        alert('CADs marked as reviewed.')
        this.closeModal()
      }
    })
  }

  render() {
    let {open, accountName, reviewDate, comment} = this.state

    return (
      <React.Fragment>
        <Modal size='mini' open={open} onClose={this.closeModal} closeIcon>
          <Modal.Header>Mark as Reviewed</Modal.Header>
          <Modal.Content>
            <div style={{marginBottom: '6px'}}>Contact</div>
            <Dropdown placeholder='Contact' fluid selection search options={this.props.salesHistoryAccounts}
              onChange={this.fieldOnChange} name='accountName' value={accountName} style={{marginBottom: '16px'}}
            />
            <div style={{marginBottom: '6px'}}>Date</div>
            <input type='date' value={reviewDate} onChange={this.onDateChange} style={{width: '100%', marginBottom: '16px'}}/>
            <div style={{marginBottom: '6px'}}>Comment</div>
            <TextArea value={comment} onChange={this.onCommentChange} rows={5} style={{width: '100%'}}/>
          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={this.closeModal}>Cancel</Button>
            <Button primary onClick={this.save}>
              <Icon name='check circle outline'/> Mark Reviewed
            </Button>
          </Modal.Actions>
        </Modal>
        <Popup content='Bulk mark as reviewed' position='right center'
          trigger={
            <Button onClick={this.openModal} basic circular icon='check circle outline' style={buttonStyle}/>
          }
        />
      </React.Fragment>
    )
  }
}

const buttonStyle = {marginTop: '2px'}

export default BulkMarkReviewedByBuyer
